import { observer } from 'mobx-react-lite'
import { StyleSheet, View } from 'react-native'
import { ActionHint } from '@ppwr/poker'

import { DS } from '../../../../design-system'
import { useStore } from '../../../../models'
import { RaiseOrFoldStep } from '../../../../models/game/walkthrough/raise-or-fold'
import { InfoRectangle } from '../../InfoRectangle'

export const RaiseOrFold = observer(({ onPlayerAction }: { onPlayerAction: (action: ActionHint) => void }) => {
  const {
    game: { currentStep }
  } = useStore()

  const step = currentStep as RaiseOrFoldStep

  return (
    <View style={styles.container}>
      <View style={styles.viewForLayout} />
      <View style={styles.buttonsContainer}>
        <DS.Button
          variant="Large/Primary"
          type="On Dark"
          onPress={() => onPlayerAction(ActionHint.RAISE)}
          rightIcon={<DS.Icon name="Arrow--top-right" size={16} color="Global/Black" />}
          maxWidth
        >
          Raise
        </DS.Button>
        <DS.Button
          variant="Large/Primary"
          type="On Light"
          style={{ backgroundColor: DS.palette['Brand/Maroon'] }}
          onPress={() => onPlayerAction(ActionHint.FOLD)}
          rightIcon={<DS.Icon name="Arrow--bottom-right" size={16} color="Global/White" />}
          maxWidth
        >
          Fold
        </DS.Button>
      </View>
      <View style={styles.viewForLayout} />
      <InfoRectangle row gap={8}>
        <View style={styles.dotStyle} />
        {step?.id === 'bettina' ? (
          <DS.Text variant="Caption/Bold">SHOULD YOU RAISE OR FOLD?</DS.Text>
        ) : (
          <DS.Text variant="Caption/Bold">REVIEW {`${step.id.toUpperCase()}'S`} HAND</DS.Text>
        )}
      </InfoRectangle>
    </View>
  )
})

const styles = StyleSheet.create({
  container: {
    flex: 1,
    marginHorizontal: 10
  },
  viewForLayout: {
    flex: 1
  },
  buttonsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 10
  },
  dotStyle: {
    height: 8,
    width: 8,
    backgroundColor: DS.palette['Brand/Orange'],
    borderRadius: 50
  }
})
